import React from 'react';
import { Button } from '~/shared/components/buttons/Button';
import { FilterBar } from '~/shared/components/filter-bar/FilterBar';
import { useQueryDataTableOptions } from './useQueryDataTableOptions';

export function QueryDataTableFilterBar({ onRefresh, children }: { onRefresh?: () => void; children: React.ReactNode }) {
	const { clearSearchOptions, filtersEmpty } = useQueryDataTableOptions();
	const showClear = !filtersEmpty;
	return (
		<FilterBar
			actions={
				(showClear || onRefresh) && (
					<>
						{showClear && <Button appearance="outline" intent="info" onClick={clearSearchOptions} label="Clear Filters" />}
						{onRefresh && <Button actionType="refresh" onClick={onRefresh} appearance="outline" intent="info" label="Refresh" />}
					</>
				)
			}
		>
			{children}
		</FilterBar>
	);
}
